import { ref } from "vue";
import L from 'leaflet';
import { GET_SERVER_REQUEST, imageUrl } from "./ServerConnect";

export const previewImageFile = ref(null);
export const previewImage = ref(null);

export const deviceCustomMarker = {
  // 기본 이미지 또는 업로드한 이미지 반환
  getMarkerImage() {
    return Get_Setting_Image('marker_now_icon') || Get_Setting_Image('marker_default_icon');
  },

  createIcon(isSelected, speed, groupImage) {
    return L.divIcon({
      html: `<div class="${isSelected ? 'selected-' : ''}origin-marker">
               <img src="${groupImage || this.getMarkerImage()}" style="width: 40px; height: 40px;" />
               ${(speed > 0) ? '<span style="position: absolute; bottom: -17px; right: 0; left: 0; background: white; color: black; border-radius: 10px; padding: 1px 2px; font-size: 11px;">' + Math.round(speed) + '</span>' : ''}
             </div>`,
      iconSize: [40, 40],
      className: '', // 기본 스타일 제거
    });
  },

  createIcon_GrayScale(isSelected, speed = 0, groupImage) {
    return L.divIcon({
      html: `<div class="${isSelected ? 'selected-' : ''}grayscale-marker">
               <img src="${groupImage || this.getMarkerImage()}" style="width: 40px; height: 40px;" />
               ${(speed > 0) ? '<span style="position: absolute; bottom: -17px; right: 0; left: 0; background: white; color: black; border-radius: 10px; padding: 1px 2px; font-size: 11px;">' + Math.round(speed) + '</span>' : ''}
             </div>`,
      iconSize: [40, 40],
      className: '', // 기본 스타일 제거
    });
  },
};
//#endregion

//#region 장치 이미지 캐싱
import defaultDeviceIcon from '@/assets/images/person.svg';
import { Get_Setting_Image } from "./Setting";
const deviceImages = ref({});

export const fetchDeviceImages = async () => {
  const response = await GET_SERVER_REQUEST('device');
  deviceImages.value = response.reduce((acc, device) => {
    acc[device.device_id] = device.device_image;
    return acc;
  }, {});
}

export const getDeviceImage = (deviceId) => {
  if (deviceImages.value[deviceId]) return imageUrl() + deviceImages.value[deviceId];
  else return defaultDeviceIcon;
}
//#endregion

//#region 그룹 이미지 캐싱
// import defaultGroupIcon from '@/assets/images/people.svg';
// export const groupImages = ref({});

// const fetchGroupImages = async () => {
//   const response = await GET_SERVER_REQUEST('group');
//   groupImages.value = response.reduce((acc, group) => {
//     acc[group.group_id] = group.group_image;
//     return acc;
//   }, {});
// }

// const updateGroupMarker = (device) => {
//   const iconUrl = groupImages.value[device.group_id] || defaultGroupIcon;
//   return L.icon({
//     iconUrl,
//     iconSize: [],
//   })
// }
//#endregion